import React, { useState, useEffect } from "react";
import {
  CardContent,
  Grid,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
} from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import { makeStyles } from "@material-ui/core/styles";
import { useQuery, useQueryClient } from "react-query";
import { useFirebase } from "../Firebase";
import { useError } from "../ErrorProvider";
import { PageHeader, AppCard, CardSkeleton } from "../UI";

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 600,
    margin: "0 auto",
  },
  cardContent: {
    padding: theme.spacing(3),
  },
  formField: {
    marginBottom: theme.spacing(3),
  },
  saveButton: {
    marginTop: theme.spacing(2),
  },
}));

const Settings = () => {
  const firebase = useFirebase();
  const { showError, showSuccess } = useError();
  const classes = useStyles();
  const queryClient = useQueryClient();

  const [automaticRewards, setAutomaticRewards] = useState(false);
  const [tremendousApiKey, setTremendousApiKey] = useState("");
  const [saving, setSaving] = useState(false);

  const { data, isLoading } = useQuery(
    "CompanySettings",
    firebase.getCompanySettings,
    {
      select: (data) => data?.data,
      onError: (err) => showError(err),
    }
  );

  useEffect(() => {
    if (data) {
      setAutomaticRewards(data.tremendousAwards || false);
      setTremendousApiKey(data.tremendousApiKey || "");
    }
  }, [data]);

  const handleSave = async (event) => {
    event.preventDefault();
    setSaving(true);

    try {
      await firebase.updateCompanySettings({
        tremendousAwards: automaticRewards,
        tremendousApiKey: tremendousApiKey,
      });
      queryClient.invalidateQueries("CompanySettings");
      queryClient.invalidateQueries("CompanyStatistics");
      showSuccess("Settings saved.");
    } catch (err) {
      showError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <PageHeader title="Settings" />
      <LoadingOverlay active={saving} spinner>
        <Grid container spacing={2}>
          {isLoading ? (
            <Grid item xs={12}>
              <div className={classes.card}>
                <CardSkeleton rows={3} />
              </div>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <AppCard className={classes.card}>
                <CardContent className={classes.cardContent}>
                    <form onSubmit={handleSave}>
                      <Box className={classes.formField}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={automaticRewards}
                              onChange={(e) =>
                                setAutomaticRewards(e.target.checked)
                              }
                              color="primary"
                            />
                          }
                          label="Automatic Rewards"
                        />
                      </Box>
                      <Box className={classes.formField}>
                        <TextField
                          label="Tremendous API Key"
                          placeholder="Enter your Tremendous API Key"
                          name="tremendousApiKey"
                          type="password"
                          variant="outlined"
                          value={tremendousApiKey}
                          onChange={(e) => setTremendousApiKey(e.target.value)}
                          fullWidth
                        />
                      </Box>
                      <Button
                        className={classes.saveButton}
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={saving}
                        fullWidth
                      >
                        {saving ? "Saving..." : "Save Settings"}
                      </Button>
                    </form>
                  </CardContent>
                </AppCard>
              </Grid>
            )}
          </Grid>
      </LoadingOverlay>
    </div>
  );
};

export default Settings;
